import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateLegalLink } from "./gsap-footer";

const LegalLinks = () => {
  const linksRef = useRef<(HTMLAnchorElement | null)[]>([]);

  const legalLinks = [
    { text: "Privacy Policy", url: "/privacy-policy" },
    { text: "Terms of Service", url: "/terms-of-service" },
    { text: "Refund Policy", url: "/refund-policy" },
    // { text: "Accessibility", url: "/accessibility" },
  ];

  useEffect(() => {
    const cleanupFunctions = linksRef.current
      .filter(Boolean)
      .map((link) => animateLegalLink(link as HTMLAnchorElement));

    return () => {
      cleanupFunctions.forEach((cleanup) => cleanup());
    };
  }, []);

  return (
    <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center">
      {legalLinks.map((link, index) => (
        <Link
          key={link.url}
          ref={(el) => (linksRef.current[index] = el)}
          to={link.url}
          className="text-gray-400 hover:text-cannabis-green-300 transition-colors duration-300 text-sm py-1 px-2 rounded hover:bg-cannabis-green-500/10"
        >
          {link.text}
        </Link>
      ))}
    </div>
  );
};

export default LegalLinks;
